import React from 'react';
const TranslatedString = ({ text }) => {
	return <>{text}</>;
};

export default TranslatedString;
